module.exports = __webpack_public_path__ + "img/category.a0747fa6.svg";